import { setQuasarHelper } from '@platform/app/mixins/renderer-vue3-fix';
import { markRaw } from 'vue';
// import FormFieldSelect from '@platform/components/form_field_select.vue';
// import RichDialog from '@platform/shared/components/rich-dialog/rich-dialog.vue';
import { localeSettings } from '@platform/shared/lib/datetime';
import MyTooltip from '@platform/components/ui/my-tooltip.vue';

let router = null;

export default function initPlatform(app, _router) {
    router = _router;
    setQuasarHelper(app.config.globalProperties.$q);
    app.config.globalProperties.$localeSettings = localeSettings;
    // app.component('FormFieldSelect', markRaw(FormFieldSelect));
    // app.component('RichDialog', markRaw(RichDialog));
    app.component('MyTooltip', markRaw(MyTooltip));
}

export const getRouter = () => {
    return router;
};
